import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

// Audit log okuma — yalnızca admin + developer (server: audit-base.routes.js).
// Contract: BayinerIOT-Workspace-/docs/api-contracts/audit-logs.md
const auditApi = createApi({
  reducerPath: "audit",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["AuditLog"],
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      getAuditLogs: builder.query({
        query: (data) =>
          apiFunction(data, `/api/audit/storageRoles/getAuditLogs`, "POST"),
        providesTags: ["AuditLog"],
      }),
    };
  },
});

export const { useGetAuditLogsQuery } = auditApi;
export { auditApi };
